var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAttachRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1388 4.19385L2.93205 9.48705C2.74452 9.67458 2.63916 9.92894 2.63916 10.1942C2.63916 10.4594 2.74452 10.7137 2.93205 10.9013C3.11959 11.0888 3.37394 11.1942 3.63916 11.1942C3.90438 11.1942 4.15873 11.0888 4.34627 10.9013L10.553 4.60806C10.7387 4.42234 10.886 4.20187 10.9866 3.95921C11.0871 3.71656 11.1388 3.45649 11.1388 3.19385C11.1388 2.9312 11.0871 2.67113 10.9866 2.42848C10.886 2.18583 10.7387 1.96535 10.553 1.77963C10.3673 1.59392 10.1468 1.4466 9.90416 1.34609C9.66151 1.24558 9.40144 1.19385 9.13879 1.19385C8.87615 1.19385 8.61608 1.24558 8.37343 1.34609C8.13078 1.4466 7.9103 1.59392 7.72458 1.77963L1.51784 8.07283C0.955231 8.63544 0.63916 9.3985 0.63916 10.1942C0.63916 10.9898 0.955231 11.7529 1.51784 12.3155C2.08045 12.8781 2.84351 13.1942 3.63916 13.1942C4.43481 13.1942 5.19787 12.8781 5.76048 12.3155L10.8888 7.19385",
    stroke: "#CD4B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachRed);
export default __webpack_public_path__ + "static/media/AttachRed.0ed9bda971bf2baa235d165640ee13fe.svg";
export { ForwardRef as ReactComponent };